export enum MEDIA_TYPES {
  IMAGE = 'IMAGE',
  EMBED = 'EMBED',
  SLIDESHOW = 'SLIDESHOW',
  FOTOWEB = 'FOTOWEB',
  ARTICLE_VIDEO = 'ARTICLE_VIDEO',
  PODCAST = 'PODCAST',
  DAILYMOTION = 'DAILYMOTION',
  THUMBNAIL = 'THUMBNAIL',
}

enum MEDIAS_META_TYPES {
  CREDIT = 'CREDIT',
  FORMAT = 'FORMAT',
  CAPTION = 'CAPTION',
  IMAGE_URL = 'IMAGE_URL',
}

const DAILYMOTION_MEDIA_TYPES = {
  VIDEO: [MEDIA_TYPES.DAILYMOTION, MEDIA_TYPES.THUMBNAIL],
};

const RICH_MEDIA_TYPES = {
  RICH: [
    MEDIA_TYPES.IMAGE,
    MEDIA_TYPES.EMBED,
    MEDIA_TYPES.ARTICLE_VIDEO,
    MEDIA_TYPES.SLIDESHOW,
    MEDIA_TYPES.PODCAST,
    MEDIA_TYPES.FOTOWEB,
  ],
};

export const MEDIA_TPL: Record<string, any> = {
  BIN: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  TEL: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  CAP: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [...RICH_MEDIA_TYPES.RICH],
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  UKSAS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [...RICH_MEDIA_TYPES.RICH],
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  DESAS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [...RICH_MEDIA_TYPES.RICH],
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  CAM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  VOI: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT],
  },
  GAL: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT],
  },
  HBZ: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...{
        ...RICH_MEDIA_TYPES,
        RICH: RICH_MEDIA_TYPES.RICH.filter(
          (mediaType) => mediaType !== MEDIA_TYPES.PODCAST,
        ),
      },
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT],
  },
  TLS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  TGC: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  TLA: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  BEA: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT],
  },
  FAC: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  SHGFAC: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  CAC: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  GEO: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  FRGSL: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  FRGSD: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  FRGSG: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  FRGSS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  FRGSV: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  FROMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  BRGTS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  BROMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  DEGTS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  DEOMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  ESGTS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  ESOMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  ITGTS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  ITOMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  UKGTS: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  UKOMM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      RICH: [
        MEDIA_TYPES.IMAGE,
        MEDIA_TYPES.EMBED,
        MEDIA_TYPES.ARTICLE_VIDEO,
        MEDIA_TYPES.FOTOWEB,
      ],
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  NEO: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  HBR: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
  SIM: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [
      MEDIAS_META_TYPES.CREDIT,
      MEDIAS_META_TYPES.CAPTION,
      MEDIAS_META_TYPES.FORMAT,
    ],
  },
  TESTBRAND: {
    FORMAT: {
      ...DAILYMOTION_MEDIA_TYPES,
      ...RICH_MEDIA_TYPES,
    },
    ALLOWED_MEDIA_METAS: [MEDIAS_META_TYPES.CREDIT, MEDIAS_META_TYPES.CAPTION],
  },
};
